<template v-if="draftInstance">
    <StoryTab
        v-if="tab == 'story'"
        :tab="tab"
        :mode="mode"
        :files="files"
        :isFileUploading="isFileUploading"
        :dataFormRequest="dataFormRequest"
        :saveAllFormData="saveAllFormData"
        :formData="formData"
        :previewMode="previewMode"
        :idUsersAssigned="idUsersAssigned"
        :requiredValidation="requiredValidation"
        :canRestoreDraft="canRestoreDraft"
        :draftInstance="draftInstance"
        @assignUsers="assignUsers"
        @unassignCurrentUser="unassignCurrentUser"
        @addFile="uploadFile"
        @generateFormData="generateFormData"
        @generateDataFormRequest="handlePreGenerateDataFormRequest"
        @saveDraft="saveDraft"
        @restoreFormData="restoreFormData"
        @saveFormData="saveFormData"
        @changePreviewDisplay="changePreviewDisplay"
        @sendPostAllPost="sendPostAllPost"
        @migratePageSaveInMainSave="migratePageSaveInMainSave"
        @retoreDraftInLocalStorage="retoreDraftInLocalStorage"
        
    />  

    <StorificationTab
        v-else-if="tab == 'storification'"
        :tab="tab"
        :mode="mode"
        :files="files"
        :isFileUploading="isFileUploading"
        :dataFormRequest="dataFormRequest"
        :saveAllFormData="saveAllFormData"
        :formData="formData"
        :previewMode="previewMode"
        :idUsersAssigned="idUsersAssigned"
        :requiredValidation="requiredValidation"
        :canRestoreDraft="canRestoreDraft"
        :draftInstance="draftInstance"
        :storificationInstance="draftInstance.form.networks.instagram.storification"
        @toogleStorificationTab="toogleStorificationTab"
        @assignUsers="assignUsers"
        @unassignCurrentUser="unassignCurrentUser"
        @addFile="uploadFile"
        @generateFormData="generateFormData"
        @generateDataFormRequest="handlePreGenerateDataFormRequest"
        @saveDraft="saveDraft"
        @restoreFormData="restoreFormData"
        @saveFormData="saveFormData"
        @changePreviewDisplay="changePreviewDisplay"
        @sendPostAllPost="sendPostAllPost"
        @migratePageSaveInMainSave="migratePageSaveInMainSave"
        @retoreDraftInLocalStorage="retoreDraftInLocalStorage"
    />
    <StandardTab 
        v-else
        :mode="mode"
        :files="files"
        :isFileUploading="isFileUploading"
        :dataFormRequest="dataFormRequest"
        :saveAllFormData="saveAllFormData"
        :formData="formData"
        :previewMode="previewMode"
        :requiredValidation="requiredValidation"
        :idUsersAssigned="idUsersAssigned"
        :canRestoreDraft="canRestoreDraft"
        :draftInstance="draftInstance"
        :requests="requests"
        @toogleStorificationTab="toogleStorificationTab"
        @assignUsers="assignUsers"
        @unassignCurrentUser="unassignCurrentUser"
        @addFile="uploadFile"
        @generateFormData="generateFormData"
        @generateDataFormRequest="handlePreGenerateDataFormRequest"
        @saveDraft="saveDraft"
        @restoreFormData="restoreFormData"
        @saveFormData="saveFormData"
        @changePreviewDisplay="changePreviewDisplay"
        @sendPostAllPost="sendPostAllPost"
        @retoreDraftInLocalStorage="retoreDraftInLocalStorage"
        

    />



</template>

<script>
import { EventBus } from '@/event-bus';

import store from '@/store/index.js';
import StandardTab from '../postCreator/StandardTab.vue';
import StoryTab from '../postCreator/StoryTab.vue';
import StorificationTab from '../postCreator/StorificationTab.vue';

import { getInfoFile, getErrorNetworkFile, postNetworkValidator } from './../postCreator/utils.js'
import SSE from './../../../utils/sse.js'
import axios from 'axios';
import html2canvas from'html2canvas'

import postMixin from '@/components/mixins/Posts.vue'
import VideoMixin from '@/components/mixins/Video.vue'
import draftMixin from '@/components/mixins/Drafts.vue'
import BotsMixin from '@/components/mixins/Bots'
import CommonMixin from '@/components/mixins/Common'

import postCreatorMixin from './../postCreator/mixins/main.js'
import { formDataDefault, maxFilesPerNetwork, listNetworkSort } from './../postCreator/constante.js'
import Checkbox from '@/components/dash/utils/checkbox.vue';

import { 
    findDifferences,
    mergeUpdates, 
    deepClone, 
    foreachSaveAllFormData,
} from './../postCreator/utils.js'


import { editableNetworks } from './../postCreator/constante'

import { buildStandardRequests, saveToDraft } from '@mashupweb/draft-lib/utils/buildRequests'
import { VueDraft, Draft } from '@mashupweb/draft-lib'

export default {

    mixins: [postMixin, draftMixin, postCreatorMixin, BotsMixin, CommonMixin, VideoMixin],

    components: {
        StandardTab,
        StoryTab,
        Checkbox,
        StorificationTab
    },

    props: {
        mode: String,
    },

    data() {
        return {
            tab: 'standard',
            saveAllFormData:{
                main: {},
                networks: {},
                pages: {},
            },
            formData: JSON.parse(JSON.stringify(formDataDefault)),
            files:{},
            idFilesGeneratingInfo: [],
            dataFormRequest : {},
            previewMode: {
                active : false,
                pageSelected: null
            },
            dataEditPost: {},
            draft: {},
            draftInstance: null,
            logs: [],
            idUsersAssigned: [],
            requiredValidation: true,
            canRestoreDraft: !!localStorage.getItem('postCreator/draftToRestore'),
            requests: null
        }
    },


    mounted() {
        this.$store.commit('selectPage/updateEnableAutoSave', false);
        EventBus.$on('postcreator/uploadFile', this.uploadFile);
        this.loadMode()
    },

    methods: {

        loadMode() {
            let saveAllFormData = null; //permet de verifier la data
        
            try {
                console.log('this.mode',this.mode)
                switch (this.mode) {
                    case 'edit':
                    case 'update': {

                        this.dataEditPost = this.$store.getters['postCreator/getDataEditPost'];

                        if (this.dataEditPost.instance) {
                            this.draftInstance = this.dataEditPost.instance
                        }
                        
                        if (this.dataEditPost.draft && this.dataEditPost.draft.saveAllFormData && this.dataEditPost.draft.files) {
                            const draft = JSON.parse(JSON.stringify(this.dataEditPost.draft))
                            this.tab = draft.tab ?? 'standard'
                            this.idUsersAssigned = draft.idUsersAssigned || []
                            this.requiredValidation = draft.requiredValidation || false
                            this.files = draft.files
                            saveAllFormData = draft.saveAllFormData
                            this.logs = this.dataEditPost.post.page[0].log
                            //enlever de la section les pages déja publié, regarder dans saveAllFormData.page[id] ou dans saveAllFormData.networks[] 

                            this.$store.commit('selectPage/updatePagesSelected', {saveToLocalStorage: false, pagesId: this.dataEditPost.posts.reduce((newSelection, post)=> (this.allPages[post.page] && newSelection.push(post.page), newSelection), [])});
                            if (this.mode == "update") EventBus.$emit('selectPageSection/freezeSelectPage', true);
                            
                          
                        }else{
                            throw new Error("Edition impossible");
                        }
                        break;
                    }
                    case 'duplicate': {
                        const dataDuplicatePost = this.$store.getters['postCreator/getDataDuplicatePost'];
                        this.draftInstance = dataDuplicatePost.instance

                        if(dataDuplicatePost && dataDuplicatePost.excludeNews) {
                            this.dataEditPost.excludeNews = dataDuplicatePost.excludeNews
                        }
                        if (dataDuplicatePost.draft && dataDuplicatePost.draft.saveAllFormData && dataDuplicatePost.draft.files) {
                            this.tab = dataDuplicatePost.draft.tab
                            this.files = dataDuplicatePost.draft.files
                            saveAllFormData = dataDuplicatePost.draft.saveAllFormData
                            this.$store.commit('selectPage/updatePagesSelected', {saveToLocalStorage: false, pagesId: dataDuplicatePost.pages.reduce((availablePages, pageId)=> (this.allPages[pageId] && availablePages.push(pageId), availablePages), [])});
                        }else{                                                            
                            throw new Error("Duplication impossible");
                        }
                        break;
                    }
                    case 'draft': {
                    
                        this.draft = this.$store.getters['postCreator/getDataDraft'];

                        if (this.draft.id && this.draft.data.saveAllFormData && this.draft.data.files) {
                            this.draftInstance = this.draft.instance

                            
                            const draft = JSON.parse(JSON.stringify({
                                ...this.draft,
                                instance: null
                            }))
                            this.tab = draft.data.tab
                            this.idUsersAssigned = draft.data.idUsersAssigned || []
                            this.requiredValidation = draft.data.requiredValidation || false
                            this.files = draft.data.files
                            saveAllFormData =  draft.data.saveAllFormData
                            this.logs = draft.data.log || []
                            this.$store.commit('selectPage/updatePagesSelected', {saveToLocalStorage: false, pagesId: this.draftInstance.pages.ids});
                        }else{
                            throw new Error("Impossible de charger le draft");
                        }
                        break;
                    }
                    case 'create': {
                        this.tab = this.$route.query.tab ?? 'standard'

                        try {
                            this.draftInstance = new VueDraft({
                                pages: this.pagesSelected,
                                form: this.tab
                            })
                            console.log('draftlib draftInstance', this.draftInstance)
                        }catch (error) {
                            console.error("draftlib Impossible de créer l'instance draft", error)
                            throw new Error("draftlib Impossible de créer l'instance draft");
                        }
                        

                        if (this.$route.query.scheduleDate) {
                            this.draftInstance.form.planifiedDate.setDate(this.$route.query.scheduleDate)
                        }
                        //todo : ajouter les users assignés
                        this.idUsersAssigned = this.getAssignUserLocalStorage()

                        
                        break;
                    }
                    default: {
                        throw new Error("Impossible de charger le mode");
                    }
                }

                if (saveAllFormData) {
                    if (this.mode !== 'update') {
                        foreachSaveAllFormData(saveAllFormData, (formData, type) => {
                            if (formData.planifiedDate && formData.planifiedDate.timestamp) {
                                if (formData.planifiedDate.timestamp < Date.now()) {
                                    if (type == 'main') {
                                        formData.planifiedDate = {
                                            date: false,
                                            hours: false,
                                            timestamp: false
                                        }
                                    }else{
                                        delete formData.planifiedDate
                                    }
                                }
                            }
                        })
                    }
                    this.saveAllFormData = saveAllFormData
                    this.formData = saveAllFormData.main
                }
            
            } catch (error) {
                console.error(error)
                this.$router.push('/dash/postCreator');
        }
        },

        toogleStorificationTab() {
            if (this.tab == 'story') return new Error("Impossible de changer de tab lorsque l'on est sur le tab story")
            this.draftInstance.form.merge.run('main')
            if (this.draftInstance.form.networks.instagram.storification.pagesActived.length == 0) {
                return new Error("Impossible de changer de tab lorsque l'on a pas de page instagram actived")
            }
            this.tab = this.tab == 'standard' ? 'storification' : 'standard'
        },

        generateFormData(pageOrNetwork = null) {
            
            console.log('generateFormData 1',pageOrNetwork)
            let formDataRef = deepClone(this.saveAllFormData.main)
            if (pageOrNetwork) {
                if(typeof pageOrNetwork === 'object' && pageOrNetwork.id){
                    //page
                    if (this.saveAllFormData.networks[pageOrNetwork.network]) mergeUpdates(formDataRef,this.saveAllFormData.networks[pageOrNetwork.network])
                    if (this.saveAllFormData.pages[pageOrNetwork.id]) mergeUpdates(formDataRef,this.saveAllFormData.pages[pageOrNetwork.id])
                }else {
                    //network
                    mergeUpdates(formDataRef,this.saveAllFormData.networks[pageOrNetwork])
                }
            }
            this.formData = formDataRef
        },

        restoreFormData(path, pageOrNetwork) {
            console.log("test12 restoreFormData",path, pageOrNetwork)
            if (!pageOrNetwork || !path) return

            if (!Array.isArray(path)) path = [path]
  
            if(typeof pageOrNetwork === 'object' && pageOrNetwork.id){
                //est une page
                if (this.saveAllFormData.pages[pageOrNetwork.id]) {
                    this.$delete(
                        [pageOrNetwork.id, ...path].slice(0,-1).reduce((acc, key) => acc[key], this.saveAllFormData.pages), 
                        path.slice(-1)[0]
                    )
                } this.$delete(this.saveAllFormData.pages[pageOrNetwork.id], path)
            }else{
                //est un network
                if (this.saveAllFormData.networks[pageOrNetwork]) {
                    this.$delete(
                        [pageOrNetwork, ...path].slice(0,-1).reduce((acc, key) => acc[key], this.saveAllFormData.networks), 
                        path.slice(-1)[0]
                    )
                }
            }    

            this.generateFormData(pageOrNetwork)    
        },

        saveFormData(pageOrNetwork) {
            console.log("test12 saveFormData", 'start', pageOrNetwork)
            if (!pageOrNetwork) {
                this.$set(this.saveAllFormData, 'main', deepClone(this.formData))
            }else{
                let formDataRef = deepClone(this.saveAllFormData.main)
                if(typeof pageOrNetwork === 'object' && pageOrNetwork.id){
                     // pageOrNetwork est une page
                    if (this.saveAllFormData.networks[pageOrNetwork.network]) mergeUpdates(formDataRef, this.saveAllFormData.networks[pageOrNetwork.network])
                    const update = findDifferences(formDataRef, this.formData)
                    this.$set(this.saveAllFormData.pages, pageOrNetwork.id, update)
                } else {
                    // pageOrNetwork est un network
                    const update = findDifferences(formDataRef, this.formData)
                    this.$set(this.saveAllFormData.networks, pageOrNetwork, update)
                } 
            }  
            console.log("test12 saveFormData", 'end')
        },

        migratePageSaveInMainSave(pageId) {
            /*Migre l'ensembe des modifications de la page dans la save main*/
            /* Si une highlight est definie dans un story alors la laisser dans la save de la page */

            if (!this.saveAllFormData.pages[pageId]) return

            const formDataPage = deepClone(this.saveAllFormData.pages[pageId])

            const newFormDataPage = {}

            //Récupérer les highlights et le retirer de la save
            if (formDataPage.storification && Object.keys(formDataPage.storification).length) {
                for (const [storyId, story] of Object.entries(formDataPage.storification)) {
                    if (story.highlight){
                        if (!newFormDataPage.storification) newFormDataPage.storification = {}
                        newFormDataPage.storification[storyId] = {
                            highlight: story.highlight
                        }
                        delete(formDataPage.storification[storyId].highlight)
                    }
                }
            }

            let formDataRef = deepClone(this.saveAllFormData.main)
            mergeUpdates(formDataRef, formDataPage)

            this.$set(this.saveAllFormData, 'main', deepClone(formDataRef))

            if (Object.keys(newFormDataPage).length) {
                this.$set(this.saveAllFormData.pages, pageId, newFormDataPage)
            }else{
                this.$delete(this.saveAllFormData.pages, pageId)
            }
        },

        async captureDivAndUpload(fileId) {
            try {
                const element = document.querySelector('.story-maker-post-creator .overflow');

                if (!element) {
                    throw new Error('Élément introuvable');
                }

                const canvas = await html2canvas(element, {
                    allowTaint: true,
                    useCORS: true
                });

                const imageB64 = canvas.toDataURL('image/png');
                const imageBlob = await fetch(imageB64).then(res => res.blob());
                const file = new File([imageBlob], `preview-post-${fileId}.png`);

                const formData = new FormData();
                formData.append('file', file);

                const response = await this.$http.post(
                    `${process.env.VUE_APP_API_HOST}/posts/upload/file`,
                    formData
                );

                return response.body.file_url;

            } catch (error) {
                console.error("Erreur lors de la capture ou de l'envoi :", error);
                return null;
            }
        },

        async saveDraft() {
            let enclosureDefault = null;
            if (this.tab == 'story') {
                alert('generate enclosure story');
                //utiliser captureDivAndUpload, faire en sorte d'utiliser l'upload file de l'instance draft
            }

            EventBus.$emit('requestManagerAdd',async (onSuccess, onProgress, onError, openWindow)=> {
                try {
                    await saveToDraft({
                        news: this.draftInstance,
                        options: {
                            currentUser: this.currentUser,
                            enclosure: enclosureDefault
                        }
                    })
                    onSuccess(`Brouillon enregistré avec succés`);
                } catch (error) {
                    console.error("Erreur lors de l'enregistrement du brouillon :", error);
                    onError(error.message);
                } finally {
                    openWindow()
                    // this.$store.commit('postCreator/setDataForDraft', this.draft);
                    this.$store.commit('selectPage/savePagesSelectedToLocalStorage');
                    this.$router.push('/dash/postCreator/draft');
                }
            }, {
                picture: enclosureDefault || this.draftInstance.form.medias?.first?.enclosure,
                title:`<span class="pink">Enregistrement du brouillon</span>`,
                loadingText: "En cours'..."
            })
        },

        async sendPostAllPost() {
            // removed for createAll and editAll
            console.warn("HERE", this.requests)

            const response = await this.requests.send()

            const requestGroup = []
            const modeKey = ['edit', 'update'].includes(this.mode) ? 'edit' : 'create';

            Object.entries(response.data.news).forEach(([pageId, news]) => {
                //detection
                const page = this.draftInstance.pages.get(pageId)
                const formFromPageId = this.requests.posts[pageId];

                requestGroup.push({
                    start: async (onSuccess, onprogress, onError) => {
                        if (formFromPageId.scheduled) {
                            onSuccess(this.$t(`dash.postCreator.send.${modeKey}.scheduled.success`));
                            EventBus.$emit('planner/refresh', 500);
                            return;
                        }
                        try {
                            console.log("editAll eventsource")
                            const eventSource = this.events(news.id);

                            eventSource.onopen = () => {
                                console.log('editAll event opened: ', news.id);
                            }
                            eventSource.onerror = (error) => {
                                console.log('editAll event onerror', error, "postId: ", news.id);
                                onError(this.$t(`dash.postCreator.send.${modeKey}.error`));
                                eventSource.close();
                            }
                            eventSource.onmessage = (event) => {
                                console.log('editAll onmessage (', news, ') : ', event)
                                if (event.data === 'keep alive') return;
                                const data = JSON.parse(event.data);
                                if (data.progress.success) {
                                    eventSource.close();
                                    onSuccess(this.$t(`dash.postCreator.send.${modeKey}.success`));
                                    EventBus.$emit('planner/refresh', 500)
                                } else if (data.progress.success === false) {
                                    eventSource.close();
                                    onError(this.$t(`dash.postCreator.send.${modeKey}.error`));
                                    EventBus.$emit('planner/refresh', 500)
                                } else {
                                    onprogress(data.progress.message);
                                }
                            }

                        } catch (error) {
                            onError(error.message)
                            return {response:null, news: { ...response.data.news, pageId }}
                        }
                    },
                    params : {
                        picture : formFromPageId.data.enclosure || page.avatar,
                        title : `<span class="pink">${page.name.charAt(0).toUpperCase() + page.name.slice(1)}</span>: ${formFromPageId.data.title || "post medias"}`,
                        loadingText: !formFromPageId.data.scheduled_date ? this.$t(`dash.postCreator.send.${modeKey}.loading`) : this.$t(`dash.postCreator.send.${modeKey}.loading_scheduled`)
                    }
                })
            });

            EventBus.$emit('requestManagerAddGroup', requestGroup, async(responses)=> {EventBus.$emit('planner/refresh', 0)});

            this.$store.commit('selectPage/savePagesSelectedToLocalStorage');

            this.$router.push({
                name: 'posts2',
                params: { 
                    date: Object.values(this.requests.posts)[0].data.scheduled_date || new Date().toISOString(),
                    scrollToHour: true
                }
            })
        },  

        async changePreviewDisplay(state, pageSelected = null) {
            console.log("changePreviewDisplay", {state, pageSelected})

            if (state) {
                if (pageSelected) {
                    this.$set(this.previewMode, 'pageSelected', pageSelected)
                }else if (!this.previewMode.pageSelected) {
                    for (let i = 0; i < listNetworkSort.length; i++) {
                        const page = this.draftInstance.pages.find(p => p.network == listNetworkSort[i])
                        if (page) {
                            this.$set(this.previewMode, 'pageSelected', page)
                            break
                        }
                    }
                }
                console.log('this.previewMode.pageSelected', this.previewMode.pageSelected)
                if (!this.previewMode.active) {
                    await this.handlePreGenerateDataFormRequest()
                    this.$set(this.previewMode, 'active', true)
                }
            }else{
                this.$set(this.previewMode, 'active', false)
                // this.$refs.postCreator.classList.remove('annimate-switch-preview-mode');

                // if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)
                // this.$nextTick(() => {
                //     this.timeOutAnnimateForm = setTimeout(() => {
                //         if (this.formShow == "preview-left") {
                //             this.formShow = "formUnique"
                //         }else{
                //             this.formShow = "formMultiple"
                //         }
                //     }, 1000);
                // })
            }
        },

        async handlePreGenerateDataFormRequest(cb) {
          
            const initRequests = async ({
                resetWaitValidation = false,
                resendUpdateNotif = false
            } = {}) => {
                this.draftInstance.usersAssigned.resetWaitValidation = resetWaitValidation
                this.draftInstance.usersAssigned.resendUpdateNotif = resendUpdateNotif
                this.requests = await buildStandardRequests(this.draftInstance, { currentUser: this.currentUser })
            }

            if (
                this.mode !== "edit" || 
                this.draftInstance.usersAssigned.length == 0 ||
                this.draftInstance.usersAssigned.ids.includes(this.currentUser.id)
            ) {
                initRequests()
                return
            }


            //reset validation donc remettre en attente de validation ?
            if (this.draftInstance.metadata.isValidate && this.draftInstance.usersAssigned.requiredValidation) {
                EventBus.$emit("showModal",
                    this.$t("dash.post.resetWaitValidation.title"),
                    this.$t("dash.post.resetWaitValidation.body"),
                    this.$t('dash.post-creator.modal.send'),
                    this.$t('dash.post-creator.modal.do-not-send'),
                    ()=>{
                        initRequests({
                            resetWaitValidation: true
                        })
                    },
                    ()=>{
                        initRequests()
                    },
                );
            }else{
                EventBus.$emit("showModal",
                    this.$t('dash.post-creator.modal.update-notification-title'),
                    this.$t('dash.post-creator.modal.update-notification-body'),
                    this.$t('dash.post-creator.modal.send'),
                    this.$t('dash.post-creator.modal.do-not-send'),
                    ()=>{
                        initRequests({
                            resendUpdateNotif: true
                        })
                    },
                    ()=>{
                        initRequests()
                    },
                );
            }
        },

        async deletePostFromClickSelectPage({pageId}) {

            const post = this.draftInstance.metadata.getPostByPageId(pageId)

            if (post && ['scheduled', 'posted'].includes(post.originalStatus)) {
                this.$store.commit('selectPage/updatePagesSelected', {saveToLocalStorage: false, pagesId: this.pagesSelected.filter(page => page.id !== pageId).map(p => p.id)})
                console.log('post.pageInstance.avatar', post)
                EventBus.$emit('requestManagerAdd',async (onSuccess, onProgress, onError)=> {

                    try {
                        const response = await post.delete({idUser: this.currentUser.id})
                    
                        this.newLog(
                            post._id, 
                            JSON.stringify(this.generateLog({
                                title: 'dash.posts.log.deleted-post-editor',
                            }))
                            , false
                        )

                        if (response.data.success) {
                            onSuccess(this.$t('dash.post-creator.request.post-deleted'));
                            this.draftInstance.pages.remove(pageId);
                        }else{
                            throw new Error(this.$t('dash.post-creator.request.post-delete-failed'));
                        }
                    } catch (error) {
                        this.$store.commit('selectPage/updatePagesSelected', {
                            saveToLocalStorage: false, 
                            pagesId:[...this.pagesSelected.map(p => p.id), post.page]
                        })
                        onError(error.message);
                    }  
                }, {
                    picture: post.pageInstance.avatar,
                    title:`<span class="pink">${post.pageInstance.name.charAt(0).toUpperCase() + post.pageInstance.name.slice(1)}</span>: ${this.$t('dash.post-creator.request.post-scheduled-label')}`,
                    loadingText: this.$t('dash.post-creator.request.deleting'),
                })
            }
        },

        getAssignUserLocalStorage() {
            const ids = JSON.parse(localStorage.getItem('postCreator/lastIdUsersAssigned') || '[]')

            return ids.filter(id => (
                id !== this.currentUser.id && 
                this.users[id] && 
                (
                    (this.users[id].admin && (!this.users[id].pages_access || this.users[id].pages_access.length == 0)) || 
                    (this.users[id].pages_access && this.users[id].pages_access.length && this.pagesSelected.every(page => this.users[id].pages_access.includes(page.id)))
                )

            ))
        },

        assignUsers() {
            //Retirer les utilisateurs qui n'ont pas accès à l'ensemble des pages sélectionnées
            const usersForSelector = Object.fromEntries(
                Object.entries(this.$store.getters['users/getUsers']).filter(([userId, user]) => 
                    user.id !== this.currentUser.id && 
                    (
                        (user.admin && (!user.pages_access || user.pages_access.length == 0)) || 
                        (user.pages_access && user.pages_access.length && this.pagesSelected.every(page => user.pages_access.includes(page.id) && !(user.role?.includes('Writter'))))
                    )
                )
            );
            console.log("usersForSelector", usersForSelector)
            EventBus.$emit('selectUsers',(idUsersSelected, formCustom)=>{          
                this.draftInstance.usersAssigned.set(idUsersSelected)   
                if (formCustom && formCustom[0] && formCustom[0].name == "optionValidation") {
                    this.draftInstance.usersAssigned.requiredValidation = formCustom[0].value
                }
                localStorage.setItem('postCreator/lastIdUsersAssigned', JSON.stringify(idUsersSelected))
            },{
                users: usersForSelector,
                defaultSelection: this.draftInstance.usersAssigned.ids,
                subTitle: this.$t('dash.post-creator.assign.subtitle'),
                validButtonText: (idUsersAssigned) => {
                    if (idUsersAssigned.length == 0) {
                        return this.$t('dash.post-creator.assign.validate')
                    }
                    if (this.draftInstance.usersAssigned.length == 0 && idUsersAssigned.length > 0) {
                        return this.$t('dash.select-users.assign')
                    }
                    if (
                        idUsersAssigned.length === this.draftInstance.usersAssigned.length &&
                        [...idUsersAssigned].sort().join() === [...this.draftInstance.usersAssigned.ids].sort().join()
                    ) {
                        return this.$t('dash.select-users.assign')
                    }

                    return this.$t('dash.post-creator.assign.update')

                },

                formCustom: [
                    {
                        type: 'checkbox',
                        name: 'optionValidation',
                        label: this.$t('dash.post-creator.assign.required-validation'),
                        value: this.draftInstance.usersAssigned.requiredValidation,
                        show: (idUsersAssigned) => idUsersAssigned.length > 0,
                    },
                ],
            })
        },

        unassignCurrentUser() {
            this.draftInstance.usersAssigned.set(
                this.draftInstance.usersAssigned.filter(id => id != this.currentUser.id)
            )
        },

        retoreDraftInLocalStorage() {
            console.log('retoreDraftInLocalStorage')
            if (this.canRestoreDraft) {
                const draftToRestore = JSON.parse(localStorage.getItem('postCreator/draftToRestore'))
                console.log('retoreDraftInLocalStorage', draftToRestore)
                if (draftToRestore) {
                    this.$store.commit('postCreator/setDataForDuplicatePost', {
                        draft: draftToRestore,
                        pages: draftToRestore.pages
                    });
                    this.canRestoreDraft = false
                    this.mode = 'duplicate'
                    this.loadMode()
                }
            
            }
        },


        async compressMedia(idFile) {
          if (!this.files[idFile]) return;

          const file = this.files[idFile];
          try {
            switch (file.info.type2) {
              case 'image':
                const resCompressImage = await this.compressImage(file.url);

                if (resCompressImage?.data?.url) {
                    this.$set(this.files[idFile], 'url', resCompressImage.data.url);
                    this.$set(this.files[idFile].info, 'enclosure', resCompressImage.data.url);
                } else {
                    this.addLog(this.currentUser, `compress-image-error`, {
                        resCompressImage: resCompressImage
                    })
                }

                if (resCompressImage.data.infos) {
                    this.$set(this.files[idFile].info, 'width', resCompressImage.data.infos.width);
                    this.$set(this.files[idFile].info, 'height', resCompressImage.data.infos.height);
                    this.$set(this.files[idFile].info, 'size', resCompressImage.data.infos.size);
                }

              break;

              case 'video':

                if (['video/x-matroska'].includes(file.type)) {

                  const sourceNormalizeVideo = new SSE(
                      `${process.env.VUE_APP_VIDEO_API_HOST}/v2/video/normalize?type=force-compress'&url=${encodeURIComponent(response.file_url)}`,
                  );
                            
                  const resNormalizeVideo = await new Promise((resolveNorm, rejectNorm) => {
                      sourceNormalizeVideo.onmessage = (eventNorm) => {
                          let responseNorm = JSON.parse(eventNorm.data);

                          if (responseNorm.success) resolveNorm(responseNorm)
                          else if (responseNorm.error || responseNorm.end) {
                              rejectNorm(responseNorm.error)
                          }else if (responseNorm.percent) {
                              this.$set(this.files[idFile], 'percentUpload', responseNorm.percent);
                          }
                      };
                      sourceNormalizeVideo.onopen = () => this.$set(this.files[idFile], 'percentUpload', 1);
                      sourceNormalizeVideo.stream((progress) => progress.lengthComputable && this.$set(this.files[idFile], 'percentUpload', (progress.loaded / progress.total) * 100));
                      sourceNormalizeVideo.onerror = (error) => {
                          console.error("error normalize video", error)
                          rejectNorm(error)
                      };
                  });

                  if (resNormalizeVideo.url) {
                      this.$set(this.files[idFile], 'url', resNormalizeVideo.url);

                      //recalcule info file
                      try {
                          const responseFetch = await fetch(resNormalizeVideo.url);
                          const blobNormalizeVideo = await responseFetch.blob();
                          const fileNormalizeVideo = new File([blobNormalizeVideo], info.name, {
                              type: blobNormalizeVideo.type,
                              lastModified: new Date().getTime()
                          });
                    
                          this.$set(this.files[idFile], 'info', await getInfoFile(fileNormalizeVideo, resNormalizeVideo.url));
                          
                      } catch (error) {
                          console.error("error get info lors de compressMedia", error)
                      }
                  }

                }

                const fetchThumbnail = async () => {
                    const res = await fetch(`https://media.mashup-web.com/video/thumbnail?url=${encodeURIComponent(this.files[idFile].url)}`);
                    const data = await res.json();
                    return data.url || null;
                };
                try {
                    let thumbnailUrl = await fetchThumbnail();
                    if (!thumbnailUrl) {
                        await new Promise(r => setTimeout(r, 2000));
                        thumbnailUrl = await fetchThumbnail();
                    }
                    if (thumbnailUrl) {
                        this.$set(this.files[idFile].info, 'enclosure', thumbnailUrl);
                    }
                } catch (e) {
                    console.error('error fetching video thumbnail', e);
                }

              break;
            }
          } catch (error) {
              console.error("error normalizing image", error);
          }
        
        },

        async compressMediaByNetwork(idFile, networks = []) {

            if (!this.files[idFile]) return;
           
            if (!Array.isArray(networks) || networks.length == 0) {
                networks = Object.values(this.pagesSelected).map(page => page.network);
            }
    
            const file = this.files[idFile];

            this.$set(file, 'isNormalizing', true);

            let errorNetworks = getErrorNetworkFile(file);

            for (const network of networks) {
                if (errorNetworks[network] && !file.normalizedNetworks[network]) {

                    try {
                        switch (file.info.type2) {
                          case 'image':
                            const resNormalizeImage = await this.normalizeImageForNetwork(file.url, network);

                            this.$set(file.normalizedNetworks, network, {
                                url: resNormalizeImage.body.url,
                                info : {
                                    width: resNormalizeImage.body.infos.width,
                                    height: resNormalizeImage.body.infos.height,
                                    size: resNormalizeImage.body.infos.size
                                }
                            });

                            break;
                        }
                         
                    } catch (error) {
                        console.error(`Echec de la normalisation de l'image pour le réseau ${network} (idFile: ${idFile}) :`, error);
                    }
                }
                
            }

            this.$set(file, 'isNormalizing', false);
        },

        async compressAllMediasByNetwork() {
            const compressPromises = Object.keys(this.files).map(idFile => new Promise(async (resolve, reject) => {
                await this.compressMediaByNetwork(idFile);
                this.$set(this.files[idFile], 'errorNetwork', getErrorNetworkFile(this.files[idFile]));
                resolve()
            }))
                
            await Promise.all(compressPromises);
        },
    },

    computed: {
        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },

        users() {
            return this.$store.getters['users/getUsers'];
        },

        pagesSelected() {
            return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
        }, 
        currentUser() {
            return this.$store.getters['users/getCurrentUser']
        },

        isFileUploading() {
            return Object.values(this.files).some(file => !file.isUpload) || this.idFilesGeneratingInfo.length > 0
        },
        
    },

    watch: {
        draftInstance() {
            console.log('-------------------------------- update draftInstance --------------------------------')
        },
        async pagesSelected(newValue, oldValue) {
            //lib-draft
            if (this.draftInstance) {
                const removePages = oldValue.filter(page => !newValue.some(p => p.id == page.id))
                const addPages = newValue.filter(page => !oldValue.some(p => p.id == page.id))

                addPages.forEach(page => {
                    this.draftInstance.pages.add(page);
                });


                 if (removePages[0]) {
                    const post = this.draftInstance.metadata.getPostByPageId(removePages[0].id)
                    if (post && ['scheduled', 'posted'].includes(post.originalStatus)) {
                        EventBus.$emit(
                            "showModal",
                            this.$t('dash.post-creator.modal.warning-title'),
                            this.$t('dash.post-creator.modal.warning-delete-scheduled'),
                            "Fermer",
                            this.$t('dash.post-creator.modal.confirm'),
                            () => {
                               this.$store.commit('selectPage/updatePagesSelected',{saveToLocalStorage: false, pagesId: oldValue.map(p => p.id)});
                            }, 
                            () => {
                                this.deletePostFromClickSelectPage({ pageId: removePages[0].id })
                            }
                        );
                    }else{
                        removePages.forEach(page => {
                            this.draftInstance.pages.remove(page.id);
                        });
                    }
                }


              


               
            }



            this.compressAllMediasByNetwork();
        },

        ['previewMode.active']: {
            immediate: true,
            handler(newValue, oldValue) {
                if (newValue) EventBus.$emit('selectPageSection/freezeSelectPage', true);   
                else EventBus.$emit('selectPageSection/freezeSelectPage', this.mode == "update");
            }
        }
    },

    beforeDestroy () {
        EventBus.$off('postcreator/uploadFile', this.uploadFile);
       

        
        switch (this.mode) {
            case "update":
                EventBus.$emit('selectPageSection/freezeSelectPage', false);    
                break;
        }
        this.$store.commit('selectPage/updateEnableAutoSave', true);
    },

    destroyed() {
        console.log('destroyed draftToRestore',  this.mode)
        switch (this.mode) {
            case "duplicate":
            case "create":
                console.log('destroyed draftToRestore')
                console.log('destroyed draftToRestore', this.mode, JSON.stringify(this.generateDraft(this.saveAllFormData, this.pagesSelected)))
                localStorage.setItem('postCreator/draftToRestore', 
                    JSON.stringify(this.generateDraft(this.saveAllFormData, this.pagesSelected))
                )
                break;
        
            default:
                break;
        }
    },

   

}
</script>
